exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mBpHYwCdk1ETAw{align-items:center;box-sizing:border-box;display:flex;height:100vh;justify-content:center;overflow:auto;width:100vw}._32SBWPAMFn2zR_{background:rgba(0,0,0,.6)}._2umAI1Blayj0Cg{background:rgba(0,0,0,.75)}._2Kmle_Ne77Dt2c{background:transparent;position:relative;top:48px;margin-bottom:80px}._2Kmle_Ne77Dt2c:focus{outline:none}._2ddgKgxwLGcW0X{align-items:flex-start}", ""]);

// exports
exports.locals = {
	"overlay": "mBpHYwCdk1ETAw",
	"light": "_32SBWPAMFn2zR_",
	"dark": "_2umAI1Blayj0Cg",
	"contents": "_2Kmle_Ne77Dt2c",
	"alignTop": "_2ddgKgxwLGcW0X"
};